/* eslint-disable @typescript-eslint/no-explicit-any */
import store from "@/store";
import axios from "axios";
import { ElMessage } from "element-plus";

// 创建axios 实例
const instance: any = axios.create({
  timeout: 60000,
  responseType: "json",
});
instance.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
if (store.getters.getToken) {
  instance.defaults.headers["Authorization"] = "Bearer " + store.getters.getToken; // 设置请求头
}

// 发送消息
const sendMessage = (message: string, type: any) => {
  ElMessage({ message, type });
  // ElMessage[type](message);
};

// 错误处理
const errorHandle = (response: { status: any; data: { message: string } }) => {
  const status = response.status;
  const other = response.data.message || "接口异常";
  switch (status) {
    case 401:
      sendMessage("账号异地登录！请联系管理员！", "error");
      break;
    case 403:
      sendMessage("登录过期，请重新登录", "error");
      break;
    case 404:
      sendMessage("请求的资源不存在", "error");
      break;
    case 405:
      sendMessage("您目前的操作有爬虫的嫌疑，请稍后再试！", "error");
      break;
    default:
      if (other) sendMessage(other, "error");
  }
};
// 请求拦截器
instance.interceptors.request.use(
  (config: any) => {
    const { isCw, isIndustry, url, params } = config;
    const bol = isCw || url.startsWith(import.meta.env.VITE_APP_API);
    config.headers.Authorization = "Bearer " + (params?.isIndustry || isIndustry ? store.getters.getIndustryToken : bol ? store.getters.getToken : store.getters.getTagCurrentData.access_token);
    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  (res: any) => {
    return Promise.resolve(res.data);
  },
  (error: { response: any }) => {
    const { response } = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response);
      return Promise.reject(response);
    }
    return Promise.reject(error);
  }
);
export default instance;
